import axios from "axios"
import config from "../config"
import { apiPath } from "../api-path"


export default function APIService() {

    return {
        async getConversation(prompt, message, id) {
            const body = {
                model: 'gemini-1.5-flash',
                prompt: prompt,
                user_uuid: id,
                message: message
            }
            return axios.post(config.api.lambda + apiPath.base_url, body, {
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => res).catch(err => console.log(err))
        },
        async postResult(body) {

            return axios.post(config.api.lambda + apiPath.result_url, body, {
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => res).catch(err => console.log(err))
        },
        
        async postInput(body) {
            return axios.post(config.api.lambda + apiPath.input, body, {
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => res).catch(err => console.log(err))
        },
        async saveEmail(body) {
            return axios.post(config.api.lambda + apiPath.save_email, body, {
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => res).catch(err => console.log(err))
        },

       
        async getTTS(body) {
            const reportApiBase = String(config.report_api?.url || "").trim();
            const lambdaBase = String(config.api?.lambda || "").trim();
            const ttsBase = reportApiBase || lambdaBase;
            return axios.post(ttsBase + apiPath.tts, body, {
                responseType: 'arraybuffer', // Ensure response is binary data
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => {
                const cache = res.headers?.['x-tts-cache'] || 'unknown';
                console.log(`[TTS] ${cache} — ${body?.voice || 'M1'} "${String(body?.input || '').slice(0, 40)}…"`);
                return res;
            }).catch(err => console.log(err))
        },
        async postSTT(file, filename, candidate_info) {
            const formData = new FormData();
            formData.append("audio_file", file, filename); // Attach file
            formData.append("info", candidate_info); // Attach file
            return axios.post(config.api.lambda + apiPath.stt, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(res => res).catch(err => console.log(err))
        },
        async nextQuestion(formsave) {
            return axios.post(config.api.lambda + apiPath.next_question, formsave, {
                headers: {
                    'Content-Type': "application/json"
                }
            }).then(res => res).catch(err => console.log(err))
        },
        
       

        

    }
}